import React from "react";
import Event from "../components/Event";
const EventScreen = () => {
  return <Event />;
};

export default EventScreen;
